import classNames from 'classnames';
import { createPortal } from 'react-dom';
import { animated } from 'react-spring';
import Item from '../Item/Item';

export default function ShadowSpace({ items, moveStyles, highlightData: [highlightedItem] }) {
  return createPortal(
    <>
      <animated.div
        className={classNames('interactive-shop__shadow-space', {
          'interactive-shop__shadow-space_active': !!highlightedItem,
        })}
        style={moveStyles}
      >
        <div
          className={classNames('interactive-shop__shadow-background', {
            'interactive-shop__shadow-background_active': !!highlightedItem,
          })}
        />
        {items.map((itemData) => {
          const { img, shadow, action, className, isFly = true } = itemData;
          const props = {
            action,
            className,
            isHidden: !highlightedItem || action !== highlightedItem,
            img,
            shadow,
            isFly,
          };
          return <Item key={action} {...props} />;
        })}
      </animated.div>
    </>,
    document.querySelector(`[data-id='free-space']`),
  );
}
